<template>
  <div class="v-overlay" :class="[classes]" :style="[styles]"
  >
    <div class="v-overlay-scrim" :style="[screamStyles]"></div>
    <div class="v-overlay-content" v-if="value">
      <slot/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VOverlay',
  props: {
    absolute: Boolean,
    color: {
      type: String,
      default: '#212121',
    },
    opacity: {
      type: [Number, String],
      default: 0.46,
    },
    value: {
      default: true,
    },
    zIndex: {
      type: [Number, String],
      default: 1090,
    },
  },
  computed: {
    classes() {
      return {
        'position-absolute': this.absolute,
        'v-overlay--active': this.value,
      }
    },
    styles() {
      return {
        'z-index': !!this.zIndex ? this.zIndex : '1090',
      }
    },
    screamStyles() {
      return {
        opacity: this.value ? this.opacity : 0,
        'background-color': !!this.color ? this.color : '#212121',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "VOverlay";
</style>
